if (!customElements.get('tab-switcher')) {
  class TabSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // [data-group] excludes plain link-tabs (Tabs section's "Link" setting) -
      // those just navigate away and never toggle a panel.
      this.tabs = Array.from(this.querySelectorAll('.tab-switcher--tab[data-group]'));
      this.tabClickHandlers = [];
      this.tabs.forEach((tab) => {
        let handler = () => this.selectGroup(tab);
        this.tabClickHandlers.push(handler);
        tab.addEventListener('click', handler);
      });

      if (this.tabs.length) {
        this.selectGroup(this.tabs[0]);
      }
    }

    disconnectedCallback() {
      this.tabs.forEach((tab, index) => {
        tab.removeEventListener('click', this.tabClickHandlers[index]);
      });
    }

    selectGroup(selectedTab) {
      const group = selectedTab.dataset.group;

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.classList.toggle('active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });

      document.querySelectorAll('[data-tab-group]').forEach((panel) => {
        panel.hidden = panel.dataset.tabGroup !== group;
      });
    }
  }

  customElements.define('tab-switcher', TabSwitcher);
}
